import { getAddress, isAddress } from 'viem'

export function checksumAddressForCopy(value: string): string {
  if (!isAddress(value, { strict: false })) return value

  try {
    return getAddress(value)
  } catch {
    return value
  }
}
